import "./styles.scss"

const NotificationPreview = ({ title, text, close }) => {
    return (
        <div className="notification-preview-modal">
            <div className="modal-header">
                <h2>Преглед на известието</h2>
                <div className="icon icon-close" onClick={close} />
            </div>
            <div className="modal-content">
                <div className="preview-phone">
                    <div className="phone-notch"></div>
                    <div className="notification-card">
                        <div className="notification-app">
                            <span className="app-name">MobiWash</span>
                            <span className="notification-time">сега</span>
                        </div>
                        <div className="notification-body">
                            <p className="notification-title">{title || 'Заглавие на известието'}</p>
                            <p className="notification-text">{text || 'Текст на съобщението...'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotificationPreview
